module.exports = __webpack_public_path__ + "static/img/gp.ecfe1701.svg";